import React from 'react'
import { FaArrowAltCircleUp, FaArrowAltCircleLeft, FaArrowAltCircleDown, FaArrowAltCircleRight} from 'react-icons/fa';
import useStore from "../StateStore/store.js"

const HtmlOverlay = () => {

    // const [isPressed, setIsPressed] = React.useState(false)

    const controllerState = useStore(state => state.touchController)

    const pressed = (e) => {
        // setIsPressed(true)
        if(e.target.id !== ""){
            controllerState.movement(e.target.id)
        }
    }

    const leave = e => {
        // setIsPressed(false)
        if(e.target.id !== ""){
            controllerState.breakMovement(e.target.id)
        }
    }


    return (
        <div id="html-overlay">
            <div id="controls">

                <div
                    onPointerDown = {e => pressed(e)}
                    onPointerUp = {e => leave(e)}
                    id = "left"
                    className = "btn"
                >
                     <FaArrowAltCircleLeft className = "icon"/>
                </div>
                <div className="center">
                    <div
                        onPointerDown = {e => pressed(e)}
                        onPointerUp = {e => leave(e)}
                        id = "forward"
                        className = "btn"
                    >
                        <FaArrowAltCircleUp className = "icon"/>
                    </div>
                    <div
                        onPointerDown = {e => pressed(e)}
                        onPointerUp = {e => leave(e)}
                        id = "backward"
                        className = "btn"
                    >
                        <FaArrowAltCircleDown className = "icon"/>
                    </div>
                </div>
                <div
                    onPointerDown = {e => pressed(e)}
                    onPointerUp = {e => leave(e)}
                    id = "right"
                    className = "btn"
                >
                     <FaArrowAltCircleRight className = "icon"/>
                </div>
            </div>
            <p id = "instruction">To move around</p>
        </div>
         
        
    )
}

export default HtmlOverlay
